import React, { useEffect, useRef } from 'react';
import { InstallButton } from 'esp-web-tools';

function isEwtDialogOpen() {
  const dialog = document.querySelector('ewt-install-dialog');
  return (
    dialog && dialog._installState && dialog._installState.state === 'finished'
  );
}

async function sendAuthString(auth_string) {
  const dialog = document.querySelector('ewt-install-dialog');
  if (!dialog || !dialog.port) return false;

  const port = dialog.port;
  try {
    if ((port.writable === null) | port.writable.locked) {
      console.error('Порт недоступен для записи');
      return false;
    }

    const writer = port.writable.getWriter();
    await writer.write(new TextEncoder().encode(auth_string));
    writer.releaseLock();
    console.log('Данные успешно отправлены:', auth_string);
    return true;
  } catch (error) {
    console.error('Ошибка при отправке данных:', error);
    throw error;
  }
}

function ESPInstall({ manifest_url, disabled, auth_string, pulse }) {
  const intervalRef = useRef(null);

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  const handleButtonClick = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    intervalRef.current = setInterval(async () => {
      if (isEwtDialogOpen()) {
        try {
          const result = await sendAuthString(auth_string);
          if (result && intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
          }
        } catch (error) {
          console.error('Ошибка при отправке:', error);
        }
      }
    }, 500);
  };

  return (
    <esp-web-install-button manifest={manifest_url} onClick={handleButtonClick}>
      <button
        className={`btn-primary h-full text-nowrap ${disabled ? 'text-gray-400 hover:bg-white' : ''} ${pulse ? 'animate-pulse' : ''}`}
        disabled={disabled}
        slot="activate"
      >
        Установить прошивку через USB
      </button>
      <span slot="unsupported" className="text-sm text-red-800">
        Ваш браузер не поддерживается для установки прошивки
        <br />
        (Web Serial работает только в Google Chrome или Microsoft Edge)
      </span>
    </esp-web-install-button>
  );
}

export default ESPInstall;
